import { defaults } from 'lodash-es'
import { mapGetters } from 'vuex'

export default {
  props: {
    miniCart: {
      type: Boolean,
      default: false
    },
    enablePicker: {
      type: Boolean,
      default: false,
      required: false
    },
    enableMinicartPicker: {
      type: Boolean,
      default: false,
      required: false
    },
    stylingOptions: {
      type: Object,
      default: () => {
        return {}
      },
      required: false
    }
  },
  data () {
    return {
      stylingOptionDefaults: {
        group: 'gift_user_choice__group col-xs-12',
        groupRow: 'gift_user_choice__group_row row',
        items: 'gift_user_choice__items col-xs-12',
        groupBlock: 'gift_user_choice__group_block col-xs-12',
        groupBlockRow: 'gift_user_choice__group_block_row',
        groupBlockThumbnailBlock: 'gift_user_choice__group_block_thumbnail_block col-xs-2',
        groupBlockThumbnailBlockNoImage: 'gift_user_choice__group_block_thumbnail_block_no_image',
        groupBlockThumbnail: 'gift_user_choice__group_block_thumbnail',
        groupBlockDescription: 'gift_user_choice__group_block_description col-xs-10',
        groupBlockDescriptionNoImage: 'col-xs-12',
        itemsBlock: 'gift_user_choice__items_block col-xs-12',
        itemsBlockRow: 'gift_user_choice__items_block_row',
        hint: 'gift_user_choice__hint col-xs-12',
        hintRow: 'gift_user_choice__hint_row',
        hintRowMessage: 'gift_user_choice__hint_row_message',
        hintRowCounter: 'gift_user_choice__hint_row_counter',
        lniGift: 'lni lni-gift',
        giftBlock: 'mt-2 gift-choice-minicart',
        giftChoiceContent: 'col-xs-12 text-left gift-choice-content',
        giftIconBg: 'col-xs-2 gift-icon-bg',
        giftRuleDescription: 'col-xs-10 gift-rule-description',
        pickYourGift: 'col-xs-12 text-center mb-2 font-weight-bold pick-your-gift-head',
        miniCartGiftSelectionStatus: 'minicart-gift-selection-status'
      }
    }
  },
  computed: {
    ...mapGetters(['shouldGiftRuleHaveSelection']),
    prefilledStylingOptions () {
      return defaults(this.stylingOptions, this.stylingOptionDefaults)
    }
  },
  methods: {
    shouldEnablePicker (giftId = null) {
      if (giftId === null) {
        return this.enablePicker
      }
      if (!this.enablePicker) {
        return false
      }
      return this.shouldGiftRuleHaveSelection(giftId)
    },
    shouldEnableMinicartPicker (giftId = null) {
      if (giftId === null) {
        return this.enableMinicartPicker
      }
      if (!this.miniCart) {
        return false
      }
      return this.shouldGiftRuleHaveSelection(giftId)
    }
  }
}
